module.exports = __webpack_public_path__ + "img/ctrl-pauli-root-stub-down-1.f3a9d075.svg";